import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import { getDeviationType } from '../../../_helpers';
import { DeviationTypes } from '../../../../types/deviation';
import OverlayContext from './OverlayContext';
import DesktopOverlayContent from './DesktopOverlayContent';
import MobileOverlayContent from './MobileOverlayContent';
import { MobileContext } from '../../../../Context/MobileContext';
var Overlay = function (_a) {
    var deviation = _a.deviation, _b = _a.showTitle, propShowTitle = _b === void 0 ? true : _b, width = _a.width, props = __rest(_a, ["deviation", "showTitle", "width"]);
    var isMobile = useContext(MobileContext);
    var _c = useContext(OverlayContext), _d = _c.showFaveControl, showFaveControl = _d === void 0 ? true : _d, _e = _c.showCommentControl, showCommentControl = _e === void 0 ? true : _e, _f = _c.showPermanentIconWhenFaved, showPermanentIconWhenFaved = _f === void 0 ? false : _f, _g = _c.showAuthor, showAuthor = _g === void 0 ? true : _g, _h = _c.showAuthorTooltip, showAuthorTooltip = _h === void 0 ? false : _h, _j = _c.showTitle, showTitle = _j === void 0 ? propShowTitle : _j, _k = _c.isSwiperMode, isSwiperMode = _k === void 0 ? false : _k;
    var isSmall = width !== undefined && width < 250;
    var deviationType = getDeviationType(deviation);
    var canShowTitle = ![
        DeviationTypes.JOURNAL,
        DeviationTypes.LITERATURE,
        DeviationTypes.POLL,
    ].includes(deviationType);
    var contentProps = __assign(__assign({ deviation: deviation,
        width: width }, props), { showAuthor: showAuthor,
        showAuthorTooltip: showAuthorTooltip, showTitle: canShowTitle && showTitle, isSmall: isSmall,
        showPermanentIconWhenFaved: showPermanentIconWhenFaved,
        showCommentControl: showCommentControl,
        showFaveControl: showFaveControl,
        isSwiperMode: isSwiperMode });
    return isMobile ? (React.createElement(MobileOverlayContent, __assign({}, contentProps))) : (React.createElement(DesktopOverlayContent, __assign({}, contentProps)));
};
Overlay.displayName = 'Overlay';
export default Overlay;
//# sourceMappingURL=Overlay.js.map